import { VFC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Select } from '../Select';
import { MeterDetails as messages } from '../../Form/meter_details/messages';
import { useMeterModelSuggestionsStore } from '../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../utils/getSelectOptionsWithSuggestions';
import { MeterModelSuggestions } from '../../../hooks/meter_models/useMeterModelDetails';

interface BinarySelectProps {
  name: keyof Pick<MeterModelSuggestions, 'flange' | 'hotWater' | 'woltman' | 'twin_meter'>;
  value?: number;
  onChange?: (value: number) => void;
}

export const BinarySelect: VFC<BinarySelectProps> = ({ name, ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const binaryOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: [0, 1],
        suggestedValue: meterModelSuggestions?.[name]?.value,
        suggestedSelection: meterModelSuggestions?.[name]?.selection,
        labelFormatter: (value: number) =>
          intl.formatMessage(
            messages[value === 1 ? ('yes' satisfies keyof typeof messages) : ('no' satisfies keyof typeof messages)],
          ),
      }),
    [meterModelSuggestions, intl, name],
  );

  return <Select allowClear showArrow className="w-100" options={binaryOptions} {...restProps} />;
};
